import React from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { connect } from 'react-redux'
import { handleExpiredAuthState } from '../../redux/actions/authActions'
import { ApiException, ExpiredSessionException } from '../../api/exceptions'

const RejectButton = ({ apiCallback, setFile, handleExpiredAuthState, documento }) => {

  const handlerComment = async () => {

    const MySwal = withReactContent(Swal)

    /** Alert */
    MySwal.fire({ /** config */
      title: 'Motivo de rechazo',
      input: 'textarea',
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true,
      preConfirm: (comments) => {
        if(!comments) {
          MySwal.showValidationMessage(`Es necesario escribir un comentario`)
          return
        } 
        apiCallback(comments)
          .then( response => {
            setFile({...documento, aceptado: false, observaciones: comments })
            MySwal.fire({
              toast: true,
              icon: 'success',
              title:'¡El documento a sido rechazado exitosamente!',
              showConfirmButton: false,
              position: 'top-end',
              timer: 3000,
              timerProgressBar: true,
            })
          })
          .catch( error => {
            if (error instanceof ExpiredSessionException) {
              return handleExpiredAuthState();
            }
      
            MySwal.fire({
              toast: true,
              icon: 'error',
              title: (error instanceof ApiException) ? error.message : 'Hubo un error al procesar la solicitud. Intente más tarde.',
              position: 'top-end',
              timer: 3000,
              timerProgressBar: true,
            })
          })
      },
      allowOutsideClick: () => !MySwal.isLoading()
    })
  }

  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
         <strong>Rechazar documento</strong>
        </Tooltip>
      }
    >
      <Button variant="danger" onClick={handlerComment} >
        <i className=" fa fa-times"></i>
      </Button>
    </OverlayTrigger>
  )
}

export default connect(null, { handleExpiredAuthState })(RejectButton)